import { createSlice } from '@reduxjs/toolkit';

// import type { PayloadAction } from '@reduxjs/toolkit';

export interface CursoState {
    cid: string
    grupo: number,
    rol: string, 
    online: boolean
}

export interface UsuarioState {
    uid: string,
    nombre: string, 
    apellido: string,
    cursos: Array<CursoState>, 
    email: string, 
    rol: string,
    online: boolean,
}

export interface UsuariosState {
    error: string,
    usuarios: Array<UsuarioState>
    usuario: UsuarioState,
    isLoading: boolean
}

const initialState: UsuariosState = {
    error: '',
    usuarios: [],
    usuario: {
        uid: '',
        nombre: '', 
        apellido: '',
        cursos: [], 
        email: '', 
        rol: '',
        online: false,
    },
    isLoading: false
}

export const usuarioSlice = createSlice({
    name: 'usuario',
    initialState,
    reducers: {
        startLoadingUsuarios: (state) => {
            state.isLoading = true;
        },
        endLoadingUsuarios: (state) => {
            state.isLoading = false;
        },
        logout: (state) => {
            localStorage.clear();
            state.usuario = initialState.usuario;
        },
        setUsuario: (state, action) => {
            state.usuario = action.payload
        },
        setUsuarios: (state, action) => {
            state.usuarios = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { startLoadingUsuarios, endLoadingUsuarios, logout, setUsuario, setUsuarios, setError } = usuarioSlice.actions

